import { useEffect, useState } from 'react'

export function useDebounce<T>(value: T, delay = 200, cb?: () => void): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    if (debouncedValue === value) {
      return
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value)
      cb?.()
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay, cb, debouncedValue])

  return debouncedValue
}
